<!--
================================================
Un composant affichant juste une icone et un texte symbolisant une absence de résultat

* Si icone est fourni alors l' icone fonteawesome correspondante s'affichera

http://localhost:8080/fr/universal-studios/reports/summary/start=2021-08-09/end=2021-08-15?pjctArchShow=active&cltArchShow=active
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div class="NoResultComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

      <font-awesome-icon :icon="fontAwesomeIcon"  class="icon "/>
      <div class="text">{{text}}</div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'

    export default {
        name: 'NoResultComp', //utile dans vue dev tool
        // mixins: [],
        // components: {},

        props: {
            /** pour typage et validation voir :
             *  https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
             *  https://fr.vuejs.org/v2/guide/components-props.html#Validation-des-props
             **/
            fontAwesomeIcon: {
              type: Array, // si non nul l'icone fontAwesome fournie sera affichée
              required: false,
              default: false,
            },

            text: {
              type: String, // Le texte à afficher
              required: true,
            },
        },
        data: function () {
            return {
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                themeToDisplay: state => state.app.themeToDisplay
          }),



        },


        methods: {
        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

        },
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/


    //////////////////////////////////////////
    // LIGHT THEME ///////////////////////////

    .NoResultComp {
      padding: 4rem;
      color: #999;
      font-weight: bold;

      .icon {
        $size: 3.5rem;
        height: $size;
        width: $size;
        display: block;
        margin: 0 auto .5rem;
        color: lighten($brandFourth, 35%);

      }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
        color:$darkTxt;
        background: $darkBg3;
        .icon {
          color: lighten($darkBg, 5%);

        }

      }

    }
</style>
